import { ReactElement } from "react";
import { Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { DELETE_COURT_REQUEST } from "../../redux/constants";
import { getAuthState } from "../../redux/selectors";

type Props = {
  visible: boolean;
  onClose: () => void;
  court: any;
};

export function DeleteCourtModal({
  visible,
  onClose,
  court,
}: Props): ReactElement {
  const dispatch = useDispatch();
  const { currentUser } = useSelector(getAuthState);

  const onFinish = () => {
    dispatch({
      type: DELETE_COURT_REQUEST,
      payload: { court, currentUser },
    });
    onClose();
  };

  return (
    <Modal
      title="Confirm"
      centered
      visible={visible}
      onOk={onFinish}
      onCancel={onClose}
    >
      <p>Are you sure to delete {court.name}</p>
    </Modal>
  );
}
